import React from "react";
import {Box, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(1),
        columnGap: theme.spacing(1),
    },
    dot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: theme.palette.primary.main,
        opacity: 0.7,
        animation: "$pulse 1.4s ease-in-out infinite",
    },
    dotMuted: {
        background: theme.palette.primary.light,
    },
    label: {
        color: theme.palette.text.secondary,
        marginLeft: 4,
        fontSize: "0.85rem",
    },
    "@keyframes pulse": {
        "0%": {
            transform: "scale(0.8)",
            opacity: 0.4,
        },
        "40%": {
            transform: "scale(1.05)",
            opacity: 1,
        },
        "100%": {
            transform: "scale(0.8)",
            opacity: 0.4,
        },
    },
}));

export type MinimalLoaderProps = {
    label?: string;
    compact?: boolean;
};

export default function MinimalLoader({label = "Generating", compact = false}: MinimalLoaderProps) {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Box className={classes.dot} style={{animationDelay: "0ms"}}/>
            <Box className={`${classes.dot} ${classes.dotMuted}`} style={{animationDelay: "150ms"}}/>
            <Box className={classes.dot} style={{animationDelay: "300ms"}}/>
            {!compact && (
                <Typography variant="caption" className={classes.label}>
                    {label}
                </Typography>
            )}
        </Box>
    );
}
